<template>
  <div id="page-forms" class="container">
    <v-container grid-list-md fluid class="mx-auto" style="max-width: 1000px">
      <v-layout row wrap>
        <div style="width: 100%">
          <h2>Perfil</h2>
          <v-flex class="d-flex justify-center tabs-contain">
            <v-skeleton-loader
              v-if="!this.user"
              width="100%"
              type="image, article"
            ></v-skeleton-loader>
            <v-card lg10 sm12 flat v-if="this.user">
              <v-tabs grow show-arrows v-model="tab">
                <v-tabs-slider></v-tabs-slider>

                <v-tab href="#personal-info"> Dados pessoais </v-tab>
                <v-tab href="#security"> Segurança </v-tab>
                <v-tab href="#cartoes"> Cartões </v-tab>
                <v-tab href="#finances"> Financeiro </v-tab>
              </v-tabs>

              <v-tabs-items v-model="tab">
                <v-tab-item key="personal-info" value="personal-info">
                  <div style="width: 100vw"></div>
                  <profile-form
                    @new_avatar="onNewAvatar"
                    :model="this.user"
                    @submit="updateProfile"
                  ></profile-form>
                </v-tab-item>
                <v-tab-item key="security" value="security">
                  <!-- found no other way to do it-->
                  <div style="width: 100vw"></div>
                  <password-form />
                </v-tab-item>
                <v-tab-item key="cartoes" value="cartoes">
                  <div style="width: 100vw"></div>
                  <cards-form />
                </v-tab-item>
                <v-tab-item key="finances" value="finances">
                  <div style="width: 100vw"></div>
                  <orders-info-card />
                </v-tab-item>
              </v-tabs-items>
            </v-card>
          </v-flex>
        </div>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import ProfileForm from "@/components/widgets/form/ProfileForm";
import PasswordForm from "@/components/widgets/form/Password.vue";
import CardsForm from "@/components/widgets/form/CardsForm.vue";
import OrdersInfoCard from "@/components/widgets/card/OrdersInfoCard.vue";
import UserService from "@/services/users.service";

export default {
  components: {
    ProfileForm,
    CardsForm,
    PasswordForm,
    OrdersInfoCard,
  },
  data() {
    return {
      user: null,
      isUpdating: false,
      tab: "personal-info",
    };
  },
  computed: {
    isOffline() {
      if (!navigator) return false;
      return !navigator.onLine;
    },
  },
  mounted() {
    this.tab = this.$route.hash.replace("#", "");
    this.loadProfile();
    if (this.isOffline) {
      window.getApp.sendSnackMessage(
        "Você está offline, não é possivel acessar essa página",
        "error",
      );
      return;
    }
  },
  metaInfo() {
    return {
      title: "LS - Meu Perfil",
      meta: [
        {
          vmid: "description",
          name: "description",
          content: "Dados do meu perfil na plataforma de certificações",
        },
      ],
    };
  },
  methods: {
    onNewAvatar(newAvatar) {
      console.log({ newAvatar });
      this.user.avatar = newAvatar;
      this.$forceUpdate();
      this.loadProfile();
    },
    loadProfile() {
      UserService.getCurrentUser().then((response) => {
        this.user = response.data;
      });
    },
    updateProfile(model) {
      UserService.updateProfile(model)
        .then((response) => {
          window.getApp.sendSnackMessage(
            "Perfil Atualizado com Sucesso",
            "green",
          );
        })
        .catch((ex) => {
          window.getApp.sendSnackMessage(ex.message, "error");
        });
    },
  },
};
</script>

<style scoped lang="scss">
.tabs-contain .v-slide-group__prev {
  display: none !important;
}
</style>
